import { useRouteMatch } from 'react-router-dom';

/**
 * @internal
 * Be warned that this function only works when the project ID is part of the URL.
 * This means this function will break when used in remotasks / outlier contexts. I.e. a real task.
 */
export function useProjectId() {
  // Extract the project ID from the URL
  const match = useRouteMatch<{ projectId: string }>();
  return match.params.projectId;
}
